@if (!hideIfZero || balance !== 0) {
    <div [ngClass]="item.class" class="wallet-balance-card__subitem d-flex justify-content-between">
        <span>{{ item.text }}</span>
        @if (balance >= 0) {
            <span>
                {{ balance | vnCurrency }}
            </span>
        }
    </div>
}
